import React, { useState } from "react";
import { ChevronDown, CheckCircle2, Clock, CircleAlert } from "lucide-react";
import { cn } from "../../lib/utils";
import {
  Collapsible,
  CollapsibleTrigger,
  CollapsibleContent,
} from "../ui/collapsible";

const CollapsibleTaskList = ({ tasks = [], bg = "bg-card" }) => {
  const [open, setOpen] = useState(false);

  const getIcon = (status) => {
    switch (status) {
      case "done":
        return <CheckCircle2 className="w-4 h-4 text-green-600" />;
      case "inprogress":
        return <Clock className="w-4 h-4 text-orange-600" />;
      default:
        return <CircleAlert className="w-4 h-4 text-gray-400" />;
    }
  };

  const getTextStyle = (status) => {
    if (status === "done") return "line-through text-gray-400";
    return "text-gray-700";
  };

  return (
    <div className={`w-full p-4 shadow-sm ${bg}`}>
      <Collapsible open={open} onOpenChange={setOpen}>
        <div className="flex items-center justify-between cursor-pointer">
          <h2 className="font-normal text-sm text-foreground">Tasks</h2>
          <CollapsibleTrigger>
            <ChevronDown
              className={cn(
                "h-5 w-5 transition-transform text-foreground",
                open ? "rotate-180" : "rotate-0"
              )}
            />
          </CollapsibleTrigger>
        </div>

        <CollapsibleContent>
          <ul className="mt-3 space-y-3">
            {tasks.map((task, idx) => (
              <li key={idx} className="flex items-center gap-2">
                {getIcon(task.status)}
                <span className={cn("font-normal text-sm text-foreground", getTextStyle(task.status))}>
                  {task.title}
                </span>
              </li>
            ))}
          </ul>
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
}

export default CollapsibleTaskList;
